import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import {
  CampaignCostForecastDialogComponent,
  type ICampaignCostForecastDialogRequest,
} from '@principle-theorem/ng-principle-shared';
import { type IMarketingCampaign } from '@principle-theorem/principle-core/interfaces';
import { type WithRef, snapshot } from '@principle-theorem/shared';
import { type Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ManagementResource } from '../models/management-resource';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class CampaignCostForecastTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);

  readonly name = 'campaign-cost-forecast';
  readonly label = 'Cost Forecast';
  readonly icon = 'trending_up';
  readonly description = 'Forecast campaign costs over a given time period';
  readonly resource = ManagementResource.MarketingCampaign;

  isDisabled(context: IToolRunContext): Observable<boolean> {
    if (!context.resource) {
      return of(true);
    }
    return context.resource.value$.pipe(map((value) => !value));
  }

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const campaign = (await snapshot(
      context.resource.value$
    )) as WithRef<IMarketingCampaign>;
    if (!campaign) {
      return;
    }
    const data: ICampaignCostForecastDialogRequest = { campaign };
    this._dialog.open(
      CampaignCostForecastDialogComponent,
      DialogPresets.medium({ data })
    );
  }
}
